import React from 'react';
import { Dropdown } from 'semantic-ui-react';

import FormFieldArray from '~/views/common/FormFieldArray';
import Section from '~/views/common/Section';

import mapping from '~/utils/mapping.json';


const Licenses = () => (
    <Section name="Licenses">
        <FormFieldArray
            control={Dropdown}
            name="licenses"
            label="Products"
            options={mapping.license.by_item}
            width={6}
        />
    </Section>
);

export default Licenses;
